export default __webpack_public_path__ + "static/media/learose2-1920w.51ed89b2.webp";